<template lang="">
    <div class="mt-5">
        <div class="notification-list container">
            <div class="mt-5">
                <h2 class="default fwb">Liste des notifications</h2><br>

                <!-- <div>
                    <ul class="list-none p-0 d-md-flex align-items-center gap-2 float-md-end">
                        <div class="d-flex align-items-center justify-content-between gap-1">
                            <li class=""><button class="btn p-0 text-primary fwb">Tous</button></li>
                            <li class=""><button class="btn p-0 text-primary fwb">Non lus</button></li>
                            <li class="">
                                <select class="form-select" aria-label="Default select example">
                                    <option selected>En cours</option>
                                    <option value="1">Annuler</option>
                                    <option value="2">Terminer</option>
                                </select>
                            </li>
                        </div>
                        <li class="/alertesmt-2 mt-md-0"><input type="text" v-model="search" @keyup="searchAlerte($event)" class="form-control" placeholder="rechercher..."></li>
                    </ul>
                </div><br> -->
            </div>
        </div>

        <div class="container-fluid w-100 shadow">
            <div class="">
                <div class="bg-transparent d-none d-md-block ">
                    <ul class="list-none p-0 px-2 d-flex row-lg gap-2 justify-content-between font-weight-bold">
                        <!-- <li class="col-lg ml-2"><input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" /></li> -->
                        <li class="col-lg nom">Createur</li>
                        <li class="col-lg gravite">Type</li>
                        <li class="col-lg d-none d-lg-block">Date</li>
                        <!-- <li class="col-lg d-none d-lg-block">Urgence</li> -->
                        <li class="col-lg d-none d-lg-block">Action</li>
                    </ul>
                    <div class="row justify-content-center my-4 pr-2" role="status" v-if="!notifications">
                        <div class="loading"></div>
                    </div>
                    <div class="rounded shadow bg-white mb-1 taille" v-for="item in notifications.data" :key="item.id">
                        <ul class="list-none d-flex row-lg default fwn p-0 px-2 d-flex gap-2 justify-content-between">
                            <!-- <li class="col-lg "><input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" /></li> -->

                            <li class="col-lg d-flex align-items-center gap-1">
                                <!-- <i class="fas fa-circle text-primary text-i"></i> -->
                                <span class="m-0 fwb">{{item.data.creator.name}}</span>
                            </li>
                            <li class="col-lg d-none d-flex align-items-center">
                                <p>{{ item.type.includes('Alerte') ? 'Alerte' : ''}}</p>
                            </li>
                            <li class="col-lg d-none d-flex align-items-center"> {{formattedDateTime(item.created_at)}}</li>
<!-- 
                            <li class="col-lg">
                                <b-col md="4" class="py-4 text-center">
                                    <b-button class="sm" :id="`popover-1-${item.id}`">{{item.data.niveau_urgence_id}}</b-button>
                                    <b-popover :target="`popover-1-${item.data.id}`" :placement="placement" title="Description" triggers="hover focus" :content="item.data.niveau_urgence"></b-popover>
                                </b-col>
                            </li> -->
                            <li class="col-lg d-flex justify-content-between align-items-center gap-2">
                                <p class="d-lg-flex gap-1 m-0">
                                    <router-link :to="{name: 'alerte', params: {uuid: item.data.uuid}}">
                                        <p class="text-primary">Voir plus de details</p>
                                    </router-link>
                                </p>
                            </li>
                        </ul>
                        <b-collapse :id="'collapse'+item.data.id" class="mb-2">
                            <b-card class="border-0">
                                <li class="list-none mb-3 rounded card-text urgence-3 px-3 py-2 fwb">Niveau d'urgence : {{item.data.niveau_urgence}}</li>
                                <li class="list-none mb-2 card-text default fwb">Souscripteur : <span class="fwn">{{item.data.creator.name}}</span></li>
                                <li class="list-none mb-2 card-text default fwb">Plainte : <span class="fwn">{{item.data.plainte}}</span></li>
                                <li class="list-none mb-2 default">Date émission : {{formattedDateTime(item.data.created_at)}}</li>

                                <div class="d-flex gap-1 d-lg-none gap-1 text-secondary m-0 float-end">
                                    <li class="alert-icon del list-none"><i class="fas fa-trash"></i></li>
                                    <li class="alert-icon up list-none"><i class="fas fa-edit"></i></li>
                                </div>
                            </b-card>
                        </b-collapse>
                    </div>
                </div>

                <div class="shadow d-block d-md-none m-auto pt-5" >
                        <div   class="list-group list-group-flush" v-for="item in notifications.data" :key="item.id">   
                            <div class="d-flex flex-row justify-content-between w-100 p-1 my-1 list-group-item"  v-b-toggle="'collapse'+item.id">
                                <div class="" >
                                    <span for="" class="my-2 text-h5 fw-semibold">Createur:</span>
                                    <h6 class=" colorGrey text-uppercase pt-1 text-h5">{{item.data.creator.name}}</h6>
                                
                                </div>
                                <div class="when-closed">
                                    <i class="fa fa-angle-down px-2 text-dark text-h5"></i>
                                </div>
                                <div class="when-open">
                                    <i class="fa fa-angle-right px-2 text-dark text-h5 "></i>
                                </div>
                            </div>          
                            <b-collapse :id="'collapse'+item.id" class="mb-2 w-100">
                                <b-card>
                                    <div class="row">
                                        <p ><span class="col-7 text-h5 fw-semibold">Type notification:</span><span class="col-5">{{ item.type.includes('Alerte') ? 'Alerte' : ''}}</span></p>
                                    </div>
                                    <div class="row ">
                                        <p><span class="col-7 text-h5 fw-semibold">Date notification:</span><span class="col-5">{{formattedDateTime(item.created_at)}}</span></p>
                                    </div>
                                    <div class="d-flex mt-2 justify-content-center w-100">
                                        <router-link :to="{name: 'alerte', params: {uuid: item.data.uuid}}" size="sm" class="btn btn-dark px-2 fw-bold text-h5 w-100">
                                            <i class="fa fa-eye px-1"></i><span class="px-1">Voir </span>
                                        </router-link>
                                    </div>
                                </b-card>
                            </b-collapse>
                        </div>
                    </div>
                </div>

            <div>
                <div class="mt-3 float-right">
                    <nav aria-label="Page navigation example">
                        <ul class="pagination justify-content-center">
                            <li :class="`page-item ${notifications.current_page == notifications.from ? 'disabled' : ''}`"><a class="page-link" href="#" @click="previous(notifications.current_page)" tabindex="-1" aria-disabled="true"> <span aria-hidden="true">&laquo;</span></a></li>
                            <li :class="`page-item ${notifications.current_page == n ? 'active' : ''}`" v-for="n in pages" @click="changePage(n)"><a class="page-link" href="#">{{ n }}</a></li>
                            <li class="page-item">
                                <li :class="`page-item ${notifications.current_page == notifications.last_page ? 'disabled' : ''}`"><a class="page-link" href="#" @click="next(notifications.current_page)" tabindex="-1" aria-disabled="true"> <span aria-hidden="true">&raquo;</span></a></li>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import Vue from 'vue';
import {mapGetters} from "vuex";
import Multiselect from 'vue-multiselect'
import AppConfig from "../../constants/AppConfig";
import BaseSelected from '@/components/BaseSelected.vue'
export default {
    name: "Notifications",

    components: {
        Multiselect,
    },
    data() {
        return {
            search: "",
            loading: false,
        }
    },
    computed: {
        ...mapGetters(["notifications"]),
        pages() {
                let numShown = 3;   // This sets the number of page tabs
                numShown = Math.min(numShown, this.notifications.last_page);
                let first = this.notifications.current_page - Math.floor(numShown / 2);
                first = Math.max(first, 1);
                first = Math.min(first, this.notifications.last_page - numShown + 1);
                return [...Array(numShown)].map((k,i) => i + first);
            },

        },
    methods: {
        formattedDateTime(date) {
            if (moment(date).isValid() && date != null) {
                return moment(date).format("DD-MM-YYYY à HH:mm");
            } else {
                return date;
            }
        },
        previous(page){
            page--
            this.getNotifications(page, "", 10, this.statut_id);
        },
        next(page){
            page++
            this.getNotifications(page, "", 10, this.statut_id);
        },
        changePage(page){
            this.getNotifications(page, "", 10, this.statut_id);
        },
        getNotifications(page = 1, search = "", size = 10, statut_id = "") {
            let args = {
                page: page,
                search: search,
                size: size,
                statut_id: statut_id
            };

            this.$store.dispatch('getUnreadNotifications', { args : args });
        },
    },
    mounted() {
        this.$store.dispatch('getUnreadNotifications', { args: {} });

    }

}
</script>
<style lang="">

</style>